import { gql } from "@apollo/client";

export const GET_TIPO_PROFESIONAL_DERIVADOR = gql`
query GetTiposProfesionalDerivador {
  tiposProfesionalDerivador {
    idTipoProfesional,
    descripcion,
    abreviacion
  }
}
`;

export const adaptTipoProfesionalDerivador = (tipoProfesionalDerivador) => {
  return {
    id: tipoProfesionalDerivador?.idTipoProfesional,
    displayName: tipoProfesionalDerivador?.descripcion,
    abreviacion: tipoProfesionalDerivador?.abreviacion
  };
};

export const adaptTipoProfesionalDerivadorArray = (
allTipoProfesionalDerivador) =>
{
  return structuredClone(allTipoProfesionalDerivador)?.
  map((tipoProfesionalDerivador) => adaptTipoProfesionalDerivador(tipoProfesionalDerivador));
};